import script from "./translateText.vue?vue&type=script&setup=true&lang=js"
export * from "./translateText.vue?vue&type=script&setup=true&lang=js"

import "./translateText.vue?vue&type=style&index=0&id=b983c5e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b983c5e8"]])

export default __exports__